module.exports = __webpack_public_path__ + "img/loader.3b1cd519.gif";